/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ApiGmwGeojsonList200ResponseFeaturesInnerProperties } from "./ApiGmwGeojsonList200ResponseFeaturesInnerProperties";
import {
  ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesFromJSON,
  ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesFromJSONTyped,
  ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesToJSON,
  ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesToJSONTyped,
} from "./ApiGmwGeojsonList200ResponseFeaturesInnerProperties";
import type { ApiGmwGeojsonList200ResponseFeaturesInnerGeometry } from "./ApiGmwGeojsonList200ResponseFeaturesInnerGeometry";
import {
  ApiGmwGeojsonList200ResponseFeaturesInnerGeometryFromJSON,
  ApiGmwGeojsonList200ResponseFeaturesInnerGeometryFromJSONTyped,
  ApiGmwGeojsonList200ResponseFeaturesInnerGeometryToJSON,
  ApiGmwGeojsonList200ResponseFeaturesInnerGeometryToJSONTyped,
} from "./ApiGmwGeojsonList200ResponseFeaturesInnerGeometry";

/**
 *
 * @export
 * @interface ApiGmwGeojsonList200ResponseFeaturesInner
 */
export interface ApiGmwGeojsonList200ResponseFeaturesInner {
  /**
   *
   * @type {ApiGmwGeojsonList200ResponseFeaturesInnerTypeEnum}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInner
   */
  type: ApiGmwGeojsonList200ResponseFeaturesInnerTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInner
   */
  id: string;
  /**
   *
   * @type {ApiGmwGeojsonList200ResponseFeaturesInnerGeometry}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInner
   */
  geometry: ApiGmwGeojsonList200ResponseFeaturesInnerGeometry;
  /**
   *
   * @type {ApiGmwGeojsonList200ResponseFeaturesInnerProperties}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInner
   */
  properties: ApiGmwGeojsonList200ResponseFeaturesInnerProperties;
}

/**
 * @export
 */
export const ApiGmwGeojsonList200ResponseFeaturesInnerTypeEnum = {
  Feature: "Feature",
} as const;
export type ApiGmwGeojsonList200ResponseFeaturesInnerTypeEnum =
  (typeof ApiGmwGeojsonList200ResponseFeaturesInnerTypeEnum)[keyof typeof ApiGmwGeojsonList200ResponseFeaturesInnerTypeEnum];

/**
 * Check if a given object implements the ApiGmwGeojsonList200ResponseFeaturesInner interface.
 */
export function instanceOfApiGmwGeojsonList200ResponseFeaturesInner(
  value: object
): value is ApiGmwGeojsonList200ResponseFeaturesInner {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (value["type"] !== "Feature") return false;

  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("geometry" in value) || value["geometry"] === undefined) return false;
  if (!("properties" in value) || value["properties"] === undefined) return false;
  return true;
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerFromJSON(
  json: any
): ApiGmwGeojsonList200ResponseFeaturesInner {
  return ApiGmwGeojsonList200ResponseFeaturesInnerFromJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwGeojsonList200ResponseFeaturesInner {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    id: json["id"],
    geometry: ApiGmwGeojsonList200ResponseFeaturesInnerGeometryFromJSON(json["geometry"]),
    properties: ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesFromJSON(json["properties"]),
  };
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerToJSON(
  json: any
): ApiGmwGeojsonList200ResponseFeaturesInner {
  return ApiGmwGeojsonList200ResponseFeaturesInnerToJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerToJSONTyped(
  value?: ApiGmwGeojsonList200ResponseFeaturesInner | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    id: value["id"],
    geometry: ApiGmwGeojsonList200ResponseFeaturesInnerGeometryToJSON(value["geometry"]),
    properties: ApiGmwGeojsonList200ResponseFeaturesInnerPropertiesToJSON(value["properties"]),
  };
}
